import html2canvas from 'modules/html2canvas'

/**
 * チャート（div要素）をダウンロード
 */
$(document).on('click', '.img-download-html', function(){
  const extension = 'png';
  // チャートを指定するためのボタンの兄弟要素div.chart-item-contentのセレクターを取得
  const selector = get_chart_item_content_elmid($(this));
  const fileName = get_chart_title(selector);

  Array.from(document.getElementsByClassName('vis-button')).forEach(btn => {
    btn.style.display = 'none';
  });

  // div要素をcanvasに描画してダウンロード
  html2canvas(document.querySelector(selector)).then(canvas => {
    let a = document.createElement('a');
    a.href = canvas.toDataURL('image/' + extension);
    a.setAttribute('download', fileName);
    a.dispatchEvent(new MouseEvent('click'));
  });

  Array.from(document.getElementsByClassName('vis-button')).forEach(btn => {
    btn.style.display = '';
  })
});

/**
 * ファイル名を取得
 */
function get_chart_title(selector)
{
  // タイトルをセット
  let title;
  if(document.querySelector(selector +' div.chart-item__chart__header-title') != null) {
    title = document.querySelector(selector +' div.chart-item__chart__header-title').textContent;
  }
  else {
    title = document.querySelector(selector +' text.highcharts-title tspan').textContent;
  }
    // タイムスタンプ（yyyymmddhhmmss）をセット
    let timestamp = format_timestamp(new Date());
  // タイトル_タイムスタンプがファイル名
  return title + "_" + timestamp;
}

/**
 * chart-item-content要素のセレクターを取得
 */
 function get_chart_item_content_elmid(elm)
 {
   // 親要素になるdiv.chart-item、divのID付きセレクターを取得
   const chartItemId = get_elmid(elm.parents('div.chart-item'));
   return 'div.chart-item' + chartItemId + ' div.chart-item-content';
 }

/**
 * 要素のIDを取得
 */
function get_elmid(elm)
{
  if(elm.attr('id') == null){ return '';}
  return '#' + elm.attr('id')
}

/**
 * タイムスタンプ（yyyymmddhhmmss）の形式にフォーマット
 */
 function format_timestamp(date)
 {
    return date.getFullYear()
    + ('0' + (date.getMonth() + 1)).slice(-2)
    + ('0' + date.getDate()).slice(-2)
    + ('0' + date.getHours()).slice(-2)
    + ('0' + date.getMinutes()).slice(-2)
    + ('0' + date.getSeconds()).slice(-2);
 }